import { getStationDataRepository } from "../Infrastructure/StationData.repository";
import { saveListStationData, saveCountStationData } from "../Infrastructure/StationData.store";

export async function getStationData(params) {
  const { count, resources: stationData } = await getStationDataRepository(params);
  saveListStationData(stationData);
  saveCountStationData(count);
}